/**
 * The reference assistant's main entry point: the statements bubble the chat
 * draws, the native wizard screen, and the hooks the chat screen calls.
 * Statement types, the per-message state and the bubble predicates come from
 * `@/features/reference-assistant/model`, never from here, so each name has
 * one public home and the chat's render planning can load them without the
 * UI. The realtime handler comes from `@/features/reference-assistant/realtime`.
 *
 * Inside the feature, dependencies point inward: `ui` uses `hooks`, `state`
 * and `model`; `hooks` use `api`, `ports`, `state` and `model`; `api`
 * implements `ports` and maps wire shapes to `model`; `state` and `ports` use
 * `model`; `model` imports nothing from the feature or any framework.
 */
export { ExtractedStatementsBubble } from './ui/bubble/ExtractedStatementsBubble';

export { CitationWizardScreen } from './ui/wizard/CitationWizardScreen';

export { useAutoOpenReferencesReady } from './hooks/useAutoOpenReferencesReady';

export { useReferenceAssistantIntro } from './hooks/useReferenceAssistantIntro';

export { useStatementReferences } from './hooks/useStatementReferences';
